import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import { toUrl } from '../lib/config';

const AyaktanHastaAnketPage: React.FC = () => {
  const [formData, setFormData] = useState({
    poliklinik: 'Ortopedi',
    katilan: 'Hasta',
    cinsiyet: 'Kadın',
    yasKategorisi: '20-29',
    egitimDurumu: 'Okur-yazar değil',
    hastaneyeUlasimda: 'Tamamen Katılıyorum',
    danismaVeYonlendirme: 'Tamamen Katılıyorum',
    hastaneIcindeUlasim: 'Tamamen Katılıyorum',
    kayitIslemleri: 'Tamamen Katılıyorum',
    muayeneOlacagiDoktoruKendimSectim: 'Tamamen Katılıyorum',
    beklemeAlanininFizikiKosullariYeterliydi: 'Tamamen Katılıyorum',
    muayeneOlmakIcinBekledigimSureUygundu: 'Tamamen Katılıyorum',
    muayeneOdasininFizikiKosullariYeterliydi: 'Tamamen Katılıyorum',
    doktorumunBanaAyirdigiSureYeterliydi: 'Tamamen Katılıyorum',
    tahlilVeTetkiklerIcinVerilenRandevuSureleriUygundu: 'Tamamen Katılıyorum',
    tahlilVeTetkikSonuclariBelirlenenSureIcerindeAldim: 'Tamamen Katılıyorum',
    doktorumTarafindanHastaligimVeTedavimIleIlgiliYeterliBilgilendirmeYapildi: 'Tamamen Katılıyorum',
    muayeneVeVeTetkiklerArasindaKisiselMahremiyetimeOzenGosterildi: 'Tamamen Katılıyorum',
    hastanePersonelinBanaKarsiDavranislariSaygiKurallarinaSuygundu: 'Tamamen Katılıyorum',
    hastaneGenelOlarakTemizdi: 'Tamamen Katılıyorum',
    hastanenizSunmuOlduguHizmetlerBeklentileriniKarsiladi: 'Tamamen Katılıyorum',
    buHastaneden: 'Tamamen Katılıyorum',
    buHastaneyiAilemVeArkadaslarimaOneririm: 'Tamamen Katılıyorum',
    gorusVeOnerileriniz: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    console.log('handleSubmit çalıştı!');
    e.preventDefault();
    console.log('preventDefault çalıştı');
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);
      console.log('Try bloğu başladı');

      const url = toUrl('/api/ayaktan-hasta-anket');
      console.log('Gönderilen URL:', url);
      console.log('Gönderilen veri:', formData);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (!response.ok) {
        const errorData = await response.text();
        console.error('Hata detayı:', errorData);
        throw new Error('Anket gönderilemedi. Lütfen tekrar deneyin.');
      }

      const result = await response.json();
      console.log('Başarılı sonuç:', result);

      setSuccess(true);
      // Formu varsayılan değerlere sıfırla
      setFormData({
        poliklinik: 'Ortopedi',
        katilan: 'Hasta',
        cinsiyet: 'Kadın',
        yasKategorisi: '20-29',
        egitimDurumu: 'Okur-yazar değil',
        hastaneyeUlasimda: 'Tamamen Katılıyorum',
        danismaVeYonlendirme: 'Tamamen Katılıyorum',
        hastaneIcindeUlasim: 'Tamamen Katılıyorum',
        kayitIslemleri: 'Tamamen Katılıyorum',
        muayeneOlacagiDoktoruKendimSectim: 'Tamamen Katılıyorum',
        beklemeAlanininFizikiKosullariYeterliydi: 'Tamamen Katılıyorum',
        muayeneOlmakIcinBekledigimSureUygundu: 'Tamamen Katılıyorum',
        muayeneOdasininFizikiKosullariYeterliydi: 'Tamamen Katılıyorum',
        doktorumunBanaAyirdigiSureYeterliydi: 'Tamamen Katılıyorum',
        tahlilVeTetkiklerIcinVerilenRandevuSureleriUygundu: 'Tamamen Katılıyorum',
        tahlilVeTetkikSonuclariBelirlenenSureIcerindeAldim: 'Tamamen Katılıyorum',
        doktorumTarafindanHastaligimVeTedavimIleIlgiliYeterliBilgilendirmeYapildi: 'Tamamen Katılıyorum',
        muayeneVeVeTetkiklerArasindaKisiselMahremiyetimeOzenGosterildi: 'Tamamen Katılıyorum',
        hastanePersonelinBanaKarsiDavranislariSaygiKurallarinaSuygundu: 'Tamamen Katılıyorum',
        hastaneGenelOlarakTemizdi: 'Tamamen Katılıyorum',
        hastanenizSunmuOlduguHizmetlerBeklentileriniKarsiladi: 'Tamamen Katılıyorum',
        buHastaneden: 'Tamamen Katılıyorum',
        buHastaneyiAilemVeArkadaslarimaOneririm: 'Tamamen Katılıyorum',
        gorusVeOnerileriniz: ''
      });

      // Sayfayı yukarı kaydır
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      console.error('Catch bloğu hatası:', err);
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
      console.log('İstek tamamlandı, loading:', false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker="Bize ulaşın"
        title="İletişim"
        description="Megapark Hastanesi her an ve her zaman sizin yanınızda"
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#ffffff"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <section className="py-5 bg-light">
      <Container>
        <div className="bg-white rounded shadow-sm p-4 p-md-5">
          {/* Header */}
          <div className="mb-4">
            <h1 className="h3 mb-3">
              Ayakta Hasta <span style={{ color: '#4CAF50' }}>Deneyim Anketi</span>
            </h1>
            <p className="text-muted mb-3">
              Aşağıdaki yer alan ifadeler ile ilgili geri bildirimleriniz, sizlere daha kaliteli hizmet sunmayı hedefleyen
              hastanemiz için büyük önem taşımaktadır.
            </p>
            <p className="text-muted mb-3">
              Bu konuda göstermiş olduğunuz ilgi ve katılımınız nedeniyle şimdiden teşekkür eder, geçmiş olsun
              dileklerimizi iletriz.
            </p>
            <p className="fw-bold mb-2">Başhekim</p>
            <p className="small text-muted">
              Not: Kişisel bilgileriniz ve ankette verdiğiniz bilgileri kesinlikle gizli tutulacaktır.
            </p>
          </div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                Anketiniz başarıyla gönderildi. Görüşleriniz bizim için çok değerli.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          {/* Form */}
          <Form onSubmit={handleSubmit}>
            {/* Başvurduğu Poliklinik */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Başvurduğu Poliklinik</Form.Label>
              <Form.Select
                name="poliklinik"
                value={formData.poliklinik}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="ortopedi">Ortopedi ve Travmatoloji</option>
                <option value="kadin-dogum">Kadın Hastalıkları ve Doğum</option>
                <option value="beyin-ve-sinir-cerrahisi">Beyin ve Sinir Cerrahisi</option>
                <option value="cocuk-sagligi-ve-hastaliklari">Çocuk Sağlığı ve Hastalıkları</option>
                <option value="fizik-tedavi-ve-rehabilitasyon">Fizik Tedavi ve Rehabilitasyon</option>
                <option value="genel-cerrahi">Genel Cerrahi</option>
                <option value="ic-hastaliklari">İç Hastalıkları</option>
                <option value="kardiyoloji">Kardiyoloji</option>
                <option value="kulak-burun-bogaz">Kulak Burun Boğaz</option>
                <option value="uroloji">Üroloji</option>
              </Form.Select>
            </Form.Group>

            {/* Ankete Katılan */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Ankete Katılan</Form.Label>
              <Form.Select
                name="katilan"
                value={formData.katilan}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Hasta</option>
                <option value="hasta-yakinlari">Hasta Yakınları</option>
              </Form.Select>
            </Form.Group>

            {/* Cinsiyetiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Cinsiyetiniz</Form.Label>
              <Form.Select
                name="cinsiyet"
                value={formData.cinsiyet}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Kadın</option>
                <option value="erkek">Erkek</option>
                <option value="belirtmek-istemiyorum">Belirtmek İstemiyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Ait Olduğunuz Yaş Kategorisini Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Ait Olduğunuz Yaş Kategorisini Belirtiniz</Form.Label>
              <Form.Select
                name="yasKategorisi"
                value={formData.yasKategorisi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="20-29">20-29</option>
                <option value="30-39">30-39</option>
                <option value="40-49">40-49</option>
                <option value="50-59">50-59</option>
                <option value="60+">60+</option>
              </Form.Select>
            </Form.Group>

            {/* Eğitim Durumunuzu Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Eğitim Durumunuzu Belirtiniz</Form.Label>
              <Form.Select
                name="egitimDurumu"
                value={formData.egitimDurumu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Okur-yazar değil</option>
                <option value="ilkokul">İlkokul</option>
                <option value="ortaokul">Ortaokul</option>
                <option value="lise">Lise</option>
                <option value="universite">Üniversite</option>
                <option value="lisansustu">Lisansüstü</option>
              </Form.Select>
            </Form.Group>

            {/* Anket Soruları */}
            <div className="mt-5 mb-4">
              <h4 className="h5 fw-bold">Anket Soruları</h4>
            </div>

            {/* Soru 1 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                1.Hastaneye ulaşımda zorluk yaşamadım
              </Form.Label>
              <Form.Select
                name="hastaneyeUlasimda"
                value={formData.hastaneyeUlasimda}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 2 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                2.Danışma ve yönlendirme hizmetleri yeterliydi.
              </Form.Label>
              <Form.Select
                name="danismaVeYonlendirme"
                value={formData.danismaVeYonlendirme}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 3 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                3.Hastane içinde ulaşımını gereken birimlere kolaylıkla ulaşabildim.
              </Form.Label>
              <Form.Select
                name="hastaneIcindeUlasim"
                value={formData.hastaneIcindeUlasim}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 4 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                4.Kayıt işlemleri için çok beklemedim.
              </Form.Label>
              <Form.Select
                name="kayitIslemleri"
                value={formData.kayitIslemleri}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 5 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                5.Muayene olacağı doktoru kendim seçtim.
              </Form.Label>
              <Form.Select
                name="muayeneOlacagiDoktoruKendimSectim"
                value={formData.muayeneOlacagiDoktoruKendimSectim}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 6 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                6.Bekleme alanının fiziki koşulları yeterliydi.
              </Form.Label>
              <Form.Select
                name="beklemeAlanininFizikiKosullariYeterliydi"
                value={formData.beklemeAlanininFizikiKosullariYeterliydi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 7 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                7.Muayene olmak için beklediğim süre uygundu.
              </Form.Label>
              <Form.Select
                name="muayeneOlmakIcinBekledigimSureUygundu"
                value={formData.muayeneOlmakIcinBekledigimSureUygundu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 8 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                8.Muayene odasının fiziki koşulları yeterliydi.
              </Form.Label>
              <Form.Select
                name="muayeneOdasininFizikiKosullariYeterliydi"
                value={formData.muayeneOdasininFizikiKosullariYeterliydi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 9 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                9.Doktorumun bana ayırdığı süre yeterliydi.
              </Form.Label>
              <Form.Select
                name="doktorumunBanaAyirdigiSureYeterliydi"
                value={formData.doktorumunBanaAyirdigiSureYeterliydi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 10 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                10.Tahlil ve tetkikler için verilen randevu süreleri uygundu.
              </Form.Label>
              <Form.Select
                name="tahlilVeTetkiklerIcinVerilenRandevuSureleriUygundu"
                value={formData.tahlilVeTetkiklerIcinVerilenRandevuSureleriUygundu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 11 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                11.Tahlil ve tetkik sonuçlarını belirlenen süre içerisinde aldım.
              </Form.Label>
              <Form.Select
                name="tahlilVeTetkikSonuclariBelirlenenSureIcerindeAldim"
                value={formData.tahlilVeTetkikSonuclariBelirlenenSureIcerindeAldim}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 12 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                12.Doktorum tarafından hastalığım ve tedavim ile ilgili yeterli bilgilendirme yapıldı.
              </Form.Label>
              <Form.Select
                name="doktorumTarafindanHastaligimVeTedavimIleIlgiliYeterliBilgilendirmeYapildi"
                value={formData.doktorumTarafindanHastaligimVeTedavimIleIlgiliYeterliBilgilendirmeYapildi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 13 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                13.Muayene ve ve tetkikler arasında kişisel mahremiyetime özen gösterildi.
              </Form.Label>
              <Form.Select
                name="muayeneVeVeTetkiklerArasindaKisiselMahremiyetimeOzenGosterildi"
                value={formData.muayeneVeVeTetkiklerArasindaKisiselMahremiyetimeOzenGosterildi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 14 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                14.Hastane personelinin bana karşı davranışları saygı kurallarına suygundu.
              </Form.Label>
              <Form.Select
                name="hastanePersonelinBanaKarsiDavranislariSaygiKurallarinaSuygundu"
                value={formData.hastanePersonelinBanaKarsiDavranislariSaygiKurallarinaSuygundu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 15 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                15.Hastane genel olarak temizdi.
              </Form.Label>
              <Form.Select
                name="hastaneGenelOlarakTemizdi"
                value={formData.hastaneGenelOlarakTemizdi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 16 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                16.Hastanenin sunmuş olduğu hizmetler beklentilerini karşıladı.
              </Form.Label>
              <Form.Select
                name="hastanenizSunmuOlduguHizmetlerBeklentileriniKarsiladi"
                value={formData.hastanenizSunmuOlduguHizmetlerBeklentileriniKarsiladi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 17 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                17.Bu hastaneden, hiç kimsenin yardımına ihtiyaç duymadan ve kolayca hizmet alabildim.
              </Form.Label>
              <Form.Select
                name="buHastaneden"
                value={formData.buHastaneden}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 18 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                18.Bu hastaneyi ailem ve arkadaşlarıma tavsiye ederim.
              </Form.Label>
              <Form.Select
                name="buHastaneyiAilemVeArkadaslarimaOneririm"
                value={formData.buHastaneyiAilemVeArkadaslarimaOneririm}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="Tamamen Katılıyorum">Tamamen Katılıyorum</option>
                <option value="Katılıyorum">Katılıyorum</option>
                <option value="Kararsızım">Kararsızım</option>
                <option value="Katılmıyorum">Katılmıyorum</option>
                <option value="Hiç Katılmıyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Görüş ve Önerileriniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Varsa görüş ve önerileriniz:
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="gorusVeOnerileriniz"
                value={formData.gorusVeOnerileriniz}
                onChange={handleChange}
                placeholder="Görüş ve önerilerinizi buraya yazabilirsiniz..."
                className="form-control-lg"
              />
            </Form.Group>

            {/* Bilgilendirme Notu */}
            <div className="alert alert-info mb-4">
              <small>
                * Sağlık durumu ankete katılmak için yeterli olmayan hastalar ile 16 yaşından küçük hastalara refakat eden kişiler tanınır.
              </small>
            </div>

            {/* Submit Button */}
            <div className="d-grid gap-2 mt-5">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Anketi Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </section>
    </>
  );
};

export default AyaktanHastaAnketPage;
